import { NavLink } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowsLeftRight } from '@phosphor-icons/react';

export default function Sidebar({ department, brand, nav, isAdmin, canSwitch, onSwitch }) {
  const BrandIcon = brand.Icon;
  const bg = department === 'legal' ? brand.color : '#0F172A';
  return (
    <aside className="w-64 bg-white border-l border-slate-200 flex flex-col shrink-0 sticky top-0 h-screen" data-testid="sidebar">
      <div className="h-16 px-5 flex items-center gap-3 border-b border-slate-200">
        <div className="w-9 h-9 rounded-md flex items-center justify-center" style={{ background: bg }}>
          <BrandIcon weight="bold" size={20} style={{ color: department === 'legal' ? '#F5D9AB' : brand.color }} />
        </div>
        <div className="leading-tight">
          <div className="text-sm font-bold text-slate-900">{brand.label}</div>
          <div className="text-[10px] text-slate-500 uppercase tracking-wider">{brand.en}</div>
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto py-3">
        {nav.filter(n => !n.adminOnly || isAdmin).map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.end}
            data-testid={`nav-${n.to.replace(/\//g, '-').slice(1)}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-5 py-2.5 text-sm transition-colors ${
                isActive
                  ? 'bg-slate-900 text-white border-r-2'
                  : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
              }`
            }
            style={({ isActive }) => isActive ? { borderRightColor: brand.color } : {}}
          >
            <n.icon size={18} weight="regular" />
            <span>{n.label}</span>
          </NavLink>
        ))}
      </nav>

      {canSwitch && (
        <div className="p-3 border-t border-slate-200">
          <Button variant="outline" size="sm" onClick={onSwitch} className="w-full text-xs" data-testid="switch-dept-btn">
            <ArrowsLeftRight className="ms-1" size={14} /> تبديل الإدارة
          </Button>
        </div>
      )}

      <div className="p-4 border-t border-slate-200">
        <div className="text-xs text-slate-500">v1.1 • Multi-Department</div>
      </div>
    </aside>
  );
}
